// extracted by mini-css-extract-plugin
export var Description = "G_cc";
export var EditorialGuidelines = "G_b7";
export var GuideLines = "G_cd";
export var Title = "G_cb";
export var container = "G_b8";
export var leftColumn = "G_b9";
export var rightColumn = "G_cf";